export default {
  workstation: {
    tabs: {
      workstation: "Poste de travail",
      trend: "Tendance",
    },
    filters: {
      with: "Avec",
      without: "Sans",
      splits: "Splits",
      none: "Aucun",
    },
    sections: {
      gamelog: "Journal de matchs",
    },
    headers: {
      line: "Ligne",
      opponent: "Adversaire",
    },
    labels: {
      averagePerGame: "Moyenne par match",
      cover: "Couvrir",
    },
  },
};
